import { zoomLevel } from "zoom-level"
const clientHook = {
  mounted() {
    this.eventListener = () =>
      this.pushEventTo(this.el, "client-mounted", { zoomLevel: zoomLevel() })
    window.addEventListener("focus", this.eventListener)
    this.pushEventTo(this.el, "client-mounted", { zoomLevel: zoomLevel() })
  },
  destroyed() {
    window.removeEventListener("focus", this.eventListener)
  },
}

export { clientHook }
